export default function Stripe({className, title, children}) {
    return (
        <div className={`mt-2 md:mt-0 w-full bg-footer min-h-14 md:min-h-40 ${className}`}>
            <div className="min-h-14 md:min-h-40 bg-black bg-opacity-25  flex flex-col justify-center">
                {title && <h1 className="text-center font-msb text-2xl md:text-5xl text-white ts-1px">{title}</h1>}
                {children}
            </div>
        </div>
    )
}